"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _core = require("../../services/core");
var _utils = _interopRequireWildcard(require("../../services/utils"));
var _view = _interopRequireDefault(require("../mobility/view"));
var _view2 = _interopRequireDefault(require("../club/view"));
var _security = _interopRequireDefault(require("wever-core/dist/services/security"));
var _storage = _interopRequireDefault(require("wever-core/dist/services/storage"));
var _environment = _interopRequireDefault(require("wever-core/dist/services/environment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Core

// Logique
const Main = () => {
  const [community, setCommunity] = (0, _react.useState)();
  const [load, setLoading] = (0, _react.useState)(true);
  const [formLoading, setFormLoading] = (0, _react.useState)(false);
  const [disabled, setDisabled] = (0, _react.useState)(false);
  const [type, setType] = (0, _react.useState)('mobility');
  const [key, setKey] = (0, _react.useState)();
  const [displayHeader, setDisplayHeader] = (0, _react.useState)();
  const [referencingId, setReferencingId] = (0, _react.useState)();
  const [childCommunityId, setChildCommunityId] = (0, _react.useState)();
  const initialisation = async () => {
    // Récupère la communauté
    const key = _utils.default.getParameterByName('key');
    const typeUri = _utils.default.getParameterByName('type');
    const userToken = _utils.default.getParameterByName('token');
    const referencingId = _utils.default.getParameterByName('id');
    const headerDisplay = _utils.default.getParameterByName('displayHeader');
    const childCommunityId2 = _utils.default.getParameterByName('communityChild');
    if (userToken) {
      _security.default.authenticate(userToken);
    } else {
      _security.default.deAuthenticate();
    }
    if (referencingId) {
      setReferencingId(parseInt(referencingId, 10));
    }
    if (headerDisplay) {
      setDisplayHeader(headerDisplay);
    }
    if (childCommunityId2) {
      setChildCommunityId(parseInt(childCommunityId2, 10));
    }
    setType(typeUri ?? type);
    setKey(key);
    if (typeUri === 'club') {
      document.getElementsByTagName('wever rescencement club');
    }
    if (null === key) {
      setLoading(false);
      return;
    }
    const response = await _core._Api.post('/communities/private', {
      key
    });
    if (!response.data?.community) {
      setLoading(false);
      return;
    }
    document.getElementsByTagName('title')[0].innerHTML = `${typeUri === 'club' ? 'Adhésion club : ' : 'Fiche de référencement :'} ${response.data.community.name}`;
    setCommunity(response.data.community);
    setLoading(false);
  };

  /**
   * récupères les valeurs du formulaires les envoies pour ensuite déclancher un mail
   */
  const onSubmit = async values => {
    if (_security.default.isAuthenticated() && !childCommunityId) {
      console.warn('user is authenticated but no childCommunityId provided');
      return;
    }
    if (!values.structure) {
      _core._Notifications.warning((0, _core._translate)('common_form_warning_title'), (0, _core._translate)('common_form_warning_fields_missing'));
      return;
    }
    if (!(0, _utils.isEmailValid)(values.referent.email, _core._translate) || !(0, _utils.isPhoneValid)(values.referent.phone, _core._translate) || !(0, _utils.isSirenValid)(values.siret, _core._translate)) {
      return;
    }
    if (childCommunityId) {
      values.childCommunity = `/communities/${childCommunityId}`;
      values.state = 'accepted';
    }
    if (!values.sites || values.sites.length === 0) {
      _core._Notifications.warning((0, _core._translate)('common_form_warning_title'), (0, _core._translate)('common_form_warning_at_least_one_site'));
      return;
    }
    for (const site of values.sites) {
      if (!site.address || !site.capacity) {
        _core._Notifications.warning((0, _core._translate)('common_form_warning_title'), (0, _core._translate)('common_form_warning_site_must_be_filled_entirely'));
        return;
      }
    }
    setFormLoading(true);
    try {
      if (referencingId) {
        await _core._Api.put('/structure_referencements/' + values.id, values);
      } else {
        await _core._Api.post('/structure_referencements', values);
      }
      _core._Notifications.success((0, _core._translate)('registerapp_success'), (0, _core._translate)('registerapp_send_success'));
    } catch (e) {
      _core._Notifications.error((0, _core._translate)('registerapp_error'), (0, _core._translate)('registerapp_send_failed'));
    }
    setFormLoading(false);
    setDisabled(true);
  };
  (0, _react.useEffect)(() => {
    initialisation();
  }, []);
  if (!community || !community.id || !key) {
    return /*#__PURE__*/_react.default.createElement(_reactstrap.Spinner, null);
  }
  if (type === 'club') {
    return /*#__PURE__*/_react.default.createElement(_view2.default, {
      communityKey: key,
      community: community,
      onSubmit: onSubmit,
      loading: load,
      formLoading: formLoading,
      disabled: disabled,
      displayHeader: displayHeader === undefined ? true : displayHeader !== 'false',
      referencingId: referencingId,
      childCommunityId: childCommunityId
    });
  }
  return /*#__PURE__*/_react.default.createElement(_view.default, {
    community: community,
    onSubmit: onSubmit,
    loading: load,
    formLoading: formLoading,
    disabled: disabled,
    displayHeader: displayHeader === undefined ? true : displayHeader !== 'false',
    referencingId: referencingId,
    childCommunityId: childCommunityId
  });
};
var _default = exports.default = Main;